import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../../index.css";
import { useEffect, useState } from "react";
import { ApiManager } from "../../utils/apiManager";
import { offerMappingService, OfferData, getOfferDisplayName } from "../../utils/offerMapping";
import { BASE_URL } from "../../config";

export default function Hero({ amount }: { amount?: string | number }) {
  const [url, setUrl] = useState("");
  const [offerAmount, setOfferAmount] = useState<string>(amount ? amount.toString() : "..."); // Default to loading state
  const [offerName, setOfferName] = useState(localStorage.getItem('current_form_name') || "Offer A");

  useEffect(() => {
    if (amount) {
      setOfferAmount(amount.toString());
    }
  }, [amount]);

  useEffect(() => {
    const CheckFormValidity = async () => {
      try {
        const currentUrl = window.location.pathname;
        const parts = currentUrl.split("/").filter((part) => part !== "");
        var formNumber = parts.length > 0 ? parts[parts.length - 1] : "0";
        if (formNumber === "fest" || formNumber === "ios") {
          formNumber = "0";
        }

        const apiUrl = `${BASE_URL}/api/form/check-ios-form/?url=${formNumber}`;
        // New offer: drop the previous offer's details so later pages don't show/submit them
        if (localStorage.getItem('current_form_number') !== formNumber) {
          ['current_form_name', 'current_app_url', 'current_offer_amount'].forEach((key) => localStorage.removeItem(key));
        }
        localStorage.setItem('current_form_number', formNumber);

        const response = await ApiManager.fetchWithAbort(apiUrl);

        if (response.status === 200) {
          const data = await response.json();
          console.log("API Response:", data);

          // 1. Logic for URL and Active Forms
          if (data.active_forms && Array.isArray(data.active_forms)) {
            const activeForms: OfferData[] = data.active_forms.map((item: { url: string; name: string }) => ({
              url: item.url,
              name: item.name
            }));
            offerMappingService.updateOffers(activeForms);

            if (data.name) {
              setOfferName(data.name);
              localStorage.setItem('current_form_name', data.name);
            } else if (activeForms.length > 0) {
              const kisshtForm = activeForms.find(f => f.name.toLowerCase().includes('kissht'));
              const formToUse = kisshtForm ? kisshtForm.name : activeForms[0].name;
              setOfferName(formToUse);
              localStorage.setItem('current_form_name', formToUse);
            }
          }

          if (data.link) {
            setUrl(data.link);
            localStorage.setItem('current_app_url', data.link);
          }

          // 2. Logic for Offer Amount (Merged)
          if (data.amount) {
            setOfferAmount(data.amount.toString());
            console.log("Found amount in data.amount:", data.amount);
          } else if (data.active_forms && Array.isArray(data.active_forms) && data.active_forms.length > 0) {
            const firstForm = data.active_forms[0];
            if (firstForm.amount) {
              setOfferAmount(firstForm.amount.toString());
              console.log("Found amount in active_forms[0].amount:", firstForm.amount);
            } else {
              setOfferAmount("10"); // FALLBACK TO 10
              console.log("No amount found, using default: 10");
            }
          } else {
            setOfferAmount("10"); // FALLBACK TO 10
            console.log("No active forms or amount, using default: 10");
          }

        }
      } catch (err) {
        console.log("Error:", err);
        setOfferAmount("10"); // FALLBACK TO 10
      }
    };

    CheckFormValidity();
  }, []);

  const navigate = useNavigate();
  const appUrl: string = url;

  return (
    <Box
      id="hero"
      sx={{
        width: "100%",
        background: "#0F231A",
        pt: { xs: 12, sm: 14 },
        pb: 2,
        px: 2,
        position: "relative",
        overflow: "hidden",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center"
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flexGrow: 1,
          px: 1,
          height: "100%"
        }}
      >
        {/* Removed Fake Header, now relying on AppAppBar */}

        <Box sx={{ width: '100%', mb: 5 }}>
          <Typography sx={{ color: '#fff', fontSize: '3.4rem', fontWeight: 700, lineHeight: 1.05, letterSpacing: '-1.5px', fontFamily: '"Moan Slight", sans-serif' }}>
            Install apps.<br/>
            Get paid <span style={{ color: '#C9F23C' }}>on<br/>UPI.</span>
          </Typography>
        </Box>

        {/* Stacked Cards */}
        <Box sx={{ position: 'relative', height: '280px', width: '100%', display: 'flex', justifyContent: 'center' }}>
          {/* Card C (Back) */}
          <Box sx={{ position: 'absolute', top: 0, width: '100%', bgcolor: '#1F3B2C',border: '1px solid #2A523D', borderRadius: 4, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', transform: 'rotate(-4deg)', zIndex: 1 }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ width: 60, height: 60, bgcolor: '#2A523D', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold', fontSize: '1.2rem', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>C</Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '1.1rem', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>Offer C</Typography>
                <Typography sx={{ color: '#aaa', fontSize: 12, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>Shopping app</Typography>
              </Box>
            </Box>
            <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '1.2rem', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>+₹15</Typography>
          </Box>

          {/* Card B (Middle) */}
          <Box sx={{ position: 'absolute', top: 98, width: '100%', bgcolor: '#1F3B2C',border: '1px solid #2A523D', borderRadius: 4, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', transform: 'rotate(3deg)', zIndex: 2, boxShadow: '0 10px 20px rgba(0,0,0,0.3)' }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ width: 60, height: 60, bgcolor: '#3955A0', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold', fontSize: '1.2rem', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>B</Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '1.1rem', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>Offer B</Typography>
                <Typography sx={{ color: '#aaa', fontSize: 12, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>Game</Typography>
              </Box>
            </Box>
            <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: '1.2rem', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>+₹40</Typography>
          </Box>

          {/* Card A (Front/Dynamic) */}
          <Box sx={{ position: 'absolute', top: 195, width: '100%', bgcolor: '#fff', borderRadius: 4, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 3, boxShadow: '0 15px 30px rgba(0,0,0,0.4)' }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Box sx={{ width: 60, height: 60, bgcolor: '#0F763F', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold', fontSize: '1.4rem', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                {getOfferDisplayName(offerName).charAt(0).toUpperCase()}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Typography sx={{ color: '#000', fontWeight: 'bold', fontSize: '1.1rem', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                  {getOfferDisplayName(offerName)}
                </Typography>
                <Typography sx={{ color: '#666', fontSize: 13, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>Install & open once</Typography>
              </Box>
            </Box>
            <Box sx={{ bgcolor: '#C9F23C', px: 2, py: 1, borderRadius: 4 }}>
              <Typography sx={{ color: '#000', fontWeight: 900, fontSize: '1.2rem', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>+₹{offerAmount}</Typography>
            </Box>
          </Box>
        </Box>

        {/* Bottom Text */}
        <Typography sx={{ color: '#ffffff', fontSize: 18, px: 1, mt: 4, mb: 4, lineHeight: 1.5, width: '100%', textAlign: 'left', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
          Try new apps on your iPhone. Upload one screenshot. Money goes straight to your UPI ID.
        </Typography>

        {/* Action Button */}
        <Box sx={{ width: '100%', flexGrow: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', pb: 4 }}>
          <Button
            id="hero-install-btn"
            variant="contained"
            onClick={() => {
              if (offerAmount !== '...') localStorage.setItem('current_offer_amount', offerAmount);
              if (appUrl) localStorage.setItem('current_app_url', appUrl);
              
              // Navigate to the active offer page
              navigate('/active-offer');
            }}
            sx={{
              backgroundColor: '#C9F23C !important',
              backgroundImage: 'none !important',
              outline: 'none !important',
              color: '#000 !important',
              borderRadius: '20px',
              textTransform: 'none',
              fontSize: '1.4rem',
              fontWeight: 600,
              width: '100%',
              maxWidth: '380px',
              mx: 'auto',
              py: 4,
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              boxShadow: 'none',
              "&:hover": {
                backgroundColor: '#b3d832 !important',
                backgroundImage: 'none !important',
                boxShadow: 'none',
              }
            }}
            endIcon={<span style={{ fontWeight: 'bolder', fontSize: '1.2rem', marginLeft: 4 }}>→</span>}
          >
            Start earning
          </Button>
        </Box>

      </Container>
    </Box>
  );
}
